<template>
	<div>
		<topNavigation style="display: none" :deleteSort="[4]">
			<template v-slot:nav-top-content-isMobile-bottom>
				<homeNavIsMoblie style="width: 310px"></homeNavIsMoblie>
			</template>
		</topNavigation>
		<appMain></appMain>
	</div>
</template>
<script>
import topNavigation from '@/components/topNavigation.vue';
import appMain from './components/appMain.vue';
export default {
	name: '',
	components: {
		topNavigation,
		appMain,
	},
	mixins: [],
	props: {},
	data() {
		return {
			isMoblie: false,
		};
	},
	computed: {},
	watch: {
		MobileVerification: {
			handler(to) {
				// ////console.log(to);
				this.isMoblie = this.MobileVerification;
				// this.isMobileVt();
				// this.isMobileValue();
			},
			immediate: true,
		},
	},
	created() {},
	mounted() {},
	methods: {},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.add {
	position: absolute;
	right: 0;
	top: 60px;
}
::v-deep .searchbox {
	top: 50px;
	.search {
		border: 1px #3291f0 solid;
		border-right: 0px;
	}

	.searchbtna {
		height: 38px !important;
	}
	.searchbtnb {
		height: 38px !important;
	}
}
@media screen and (max-width: 769px) {
	.add {
		position: absolute;
		right: 0;
		top: 110px !important;
		bottom: 0px !important;
		display: flex;
		height: 38px;
	}
	.topBannerIndex {
		height: 150px !important;
		.topBannerIndexContent {
			text-align: center;
			position: relative;
			width: 100% !important;
		}
	}
}
</style>
